import { NeoModel, ValueObject } from "@singularsystems/neo-core";

@NeoModel
export default class SftpDetailsLookup extends ValueObject {
    public sftpdetailId: number = 0;

    public userName: string ="";

    public hostName: string ="";

    public port: number = 0;

    public sftpSetting: string = "";

    public rootPath: string = "";
}